<template>
  <b-modal id="predefinedMsgModal" title="Ajouté une phrase">
    <b-form @submit.stop.prevent="onSubmit">
      <b-form-group label="Messages prédéfinis" label-for="shortcut-input">
        <b-form-textarea
          placeholder="Saississez un message prédéfini..."
          rows="3"
          max-rows="6"
          no-resize
          v-model="form.message"
        ></b-form-textarea>
      </b-form-group>
    </b-form>
    <template v-slot:modal-footer="{ ok, close }">
      <b-btn pill variant="outline-secondary" @click="close()">Annulé</b-btn>

      <b-btn
        pill
        @click="onSubmit(ok)"
        variant="primary"
        :disabled="callStatus == 'fetching'"
      >
        <span>Ajouter</span>
        <b-spinner
          class="ml-2"
          small
          v-if="callStatus == 'fetching'"
        ></b-spinner
      ></b-btn>
    </template>
  </b-modal>
</template>
<script>
/**
 * @file       Predefined message modale component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "predefinedMessageModal",

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      form: {
        message: ""
      }
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      predefinedMessages: state => state.messages.messages,
      callStatus: state => state.messages.msg.status
    })
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Called on submit.
     */
    onSubmit() {
      if (this.form.message) {
        this.$store
          .dispatch("messages/postMsg", {
            message: this.form.message
          })
          .then(() => {
            this.$store.dispatch("messages/getMessages");
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
textarea {
  overflow-y: hidden !important;
}
</style>
